module.exports = __webpack_public_path__ + "img/16.428f27ec.jpg";